// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__9zEqt","modalFooterButton":"ModalNotes_modalFooterButton__3_YRF"};